module.exports = __webpack_public_path__ + "img/watermark-half.7a1d556d.svg";